import { FirebaseMessagingProvider } from 'framework/base/contexts/firebase/FirebaseMessagingProvider';
import ApolloConfigProvider from 'framework/base/utils/ApolloConfigProvider';
import IOSDetector from 'framework/base/utils/IOSDetector';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime/runtime';
import { AuthorizationProvider } from 'spec';
import App from './App';
import './App.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <Provider store={store}>
      <AuthorizationProvider>
        <ApolloConfigProvider>
          <FirebaseMessagingProvider
            onInstallationRegistered={(fid) => {
              console.info('[Moneyx FCM] Registered:', fid);
            }}
            onInstallationUnregistered={(fid) => {
              console.info('[Moneyx FCM] Unregistered:', fid);
            }}
            onNotification={(payload) => {
              console.info('[Moneyx FCM] Notification:', payload);
            }}
          >
            <IOSDetector />
            <App />
          </FirebaseMessagingProvider>
        </ApolloConfigProvider>
      </AuthorizationProvider>
    </Provider>
  </BrowserRouter>
);

if ('serviceWorker' in navigator) {
  const unregisterAllServiceWorkers = async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map((registration) => registration.unregister())
      );
      // Clean stale caches in development
      const cacheKeys = await caches.keys();
      await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    } catch (err) {
      console.warn('Failed to unregister service workers:', err);
    }
  };

  const registerServiceWorker = async () => {
    const shouldEnableServiceWorker =
      !window.Cypress &&
      (import.meta.env.PROD ||
        import.meta.env.VITE_ENABLE_SERVICE_WORKER === 'true');

    if (!shouldEnableServiceWorker) {
      await unregisterAllServiceWorkers();
      return;
    }
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/serviceWorker.js')
        .then((registration) => {
          registration.onupdatefound = () => {
            const newWorker = registration.installing;

            if (newWorker) {
              newWorker.onstatechange = () => {
                if (
                  newWorker.state === 'installed' &&
                  navigator.serviceWorker.controller
                ) {
                  window.dispatchEvent(new Event('sw.updateAvailable'));
                }
              };
            }
          };

          setInterval(() => registration.update(), 5 * 60 * 1000); // Check for updates every 5 minutes
        })
        .catch((err) => {
          console.info('Service worker registration failed:', err);
        });
    });

    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'RELOAD_PAGE') {
        window.location.reload();
      }
    });

    window.addEventListener('error', (e) => {
      if (/Loading chunk [\d]+ failed|Failed to fetch/.test(e?.message || '')) {
        caches
          .keys()
          .then((names) =>
            Promise.all(names.map((name) => caches.delete(name)))
          )
          .then(() => {
            navigator.serviceWorker
              .getRegistration()
              .then((reg) => reg?.unregister());
            window.location.reload();
          });
      }
    });
  };

  registerServiceWorker();
}

reportWebVitals();
